/**
 * Finds all modal triggers on page and create a click event listener for each.
 * When a trigger is clicked, a custom event is dispatched to show the modal.
 * Trigger elements should be clickable, and have an attribute of format
 * `js-uwp-modal-trigger="modal-name"`, where `modal-name` is the id of the
 * modal to show.
 * @returns void
 */
export function setupModalTriggers(): void {
  const modalTriggers = Array.from(
    document.querySelectorAll("[js-uwp-modal-trigger]"),
  );

  if (!modalTriggers.length) {
    return;
  }

  for (const trigger of modalTriggers) {
    trigger.addEventListener("click", () => {
      const modalId = trigger.getAttribute("js-uwp-modal-trigger");
      if (!modalId) {
        return;
      }

      document.dispatchEvent(new CustomEvent(`modal:show:${modalId}`));
    });
  }
}
